import { BookingModel } from './booking.model';

export interface LocationModel {
  _id: string;
  default: boolean;
  address: string;
  country: string;
  postalCode: string;
  city: string;
  state: string;
  timezone: string;
  bookings?: BookingModel[];
  floor?: string;
  apartment?: string;
  geometry: {
    lat: number;
    lng: number;
  };
}

export interface PostLocationModel {
  default?: boolean;
  address: string;
  country: string;
  postalCode: string;
  city: string;
  state: string;
  timezone: string;
  bookings?: BookingModel[];
  floor?: string;
  apartment?: string;
  geometry: {
    lat: number;
    lng: number;
  };
}
